/**
 * Wraps the auth-related pages (login, register, forgot-password,
 * reset-password). If the visitor is already signed in, send them to the
 * dashboard so the reset page can't appear over the top of an authenticated
 * session.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAppAuth } from '@/contexts/AppAuthContext';

export function RedirectIfAuthed({ children }) {
  const { user } = useAppAuth();
  const location = useLocation();

  // Still bootstrapping the token check — render nothing rather than flash
  // the auth page.
  if (user === undefined) return null;

  if (user) {
    // Honour any ?next= param (so legitimate redirects after sign-in still
    // work), but never bounce back to another auth-only path.
    const params = new URLSearchParams(location.search);
    const next = params.get('next');
    const isAuthPath = (p) =>
      !p ||
      p.startsWith('/login') ||
      p.startsWith('/portal-signin') ||
      p.startsWith('/register') ||
      p.startsWith('/forgot-password') ||
      p.startsWith('/reset-password');
    return <Navigate to={isAuthPath(next) ? '/' : next} replace />;
  }

  return children;
}
